import { CANtrackCaseRaw } from 'api/comments/getCases';
import { CANtrackCase } from '../types/comment';

export function convertToCANtrackCase(raw: CANtrackCaseRaw): CANtrackCase {
	return {
		id: parseInt(raw.Id),
		title: raw.Title,
		description: raw.Description,
		consultantID: parseInt(raw.ConsultantId),
		consultantName: raw.ConsultantName,
		customerName: raw.CustomerName,
		customerID: parseInt(raw.CustomerId),
		gpd: {
			group: {
				id: parseInt(raw.GroupId),
				title: raw.GroupTitle,
			},
			project: {
				id: parseInt(raw.ProjectId),
				title: raw.ProjectTitle,
			},
			deliverable: {
				id: parseInt(raw.DeliverableId),
				title: raw.DeliverableTitle,
			},
		},
		statusId: raw.StatusId ? parseInt(raw.StatusId) : undefined,
		statusTitle: raw.StatusTitle || undefined,
		statusComment: raw.StatusComment || undefined,
	};
}
